import { ulid } from "ulid";
import {BusRoute, WayPoint} from "./busRoute";
import {chunk, cloneDeep} from "lodash";
import {mapSeries} from 'async/index';
import { getCachedDirections } from "../libs/pathLib";

export class Deadrun extends BusRoute {

    static from(data) {
        return new Deadrun(data);
    }

    constructor(data) {
        super(data)
        this.startStopId = null;
        this.endStopId = null;
        this.start = null;
        this.end = null;
        this.hasDirections = false;
        Object.assign(this, data)
        // this.stops = [this.startStop, this.endStop];
        // this.stopTimes = [this.startStop, this.endStop];
        this.startStopId = this.startStopId || (this.start ? this.start.stopId || this.startStop?.stopId : null)
        this.endStopId = this.endStopId || (this.end ? this.end.stopId || this.endStop?.stopId : null)
        this.deadrun = true
        this.startWpIdx = 0;
        this.endWpIdx = this.waypoints.length - 1;
        this.createStops();
    }

    clone(field, value) {
        const newRoute = super.clone(field, value)
        newRoute.routes = cloneDeep(this.routes)
        return new Deadrun(newRoute);
    }

    createStops() {
        if(!this.start || !this.end) {
            return;
        }
        this.stops = [{...this.start, stopTimeId: ulid()}, {...this.end, stopTimeId: ulid()}];
        this.stopTimes = this.stops.map(st => ({...st}));
    }

    toJson() {
        const obj = this.clone();
        Object.keys(obj).forEach((key) => {
            if (obj[key] === null || obj[key] === undefined) {
                delete obj[key];
            }
        });
        obj.waypoints = obj.waypoints.map((wp) => {
            const {lat, lon, distance, delta} = wp;
            return {lat, lon, distance, delta};
        });
        obj.startStopId = obj.startStopId || obj.start?.stopId || obj.startStop?.stopId;
        obj.endStopId = obj.endStopId || obj.end?.stopId || obj.endStop?.stopId;
        delete obj.firstStop;
        delete obj.lastStop;
        delete obj.startStop;
        delete obj.endStop;
        delete obj.start;
        delete obj.end;
        delete obj.routes;
        delete obj.stops;
        delete obj.stopTimes;
        return obj;
    }

    async buildDirections(force) {
        try {
            // Early return if no waypoints or already has directions
            if (!this.waypoints?.length || (!force && this.hasDirections) || this.distance > 50000) {
                this.routeDetails = '';
                return;
            }
    
            // Process waypoints in chunks, maintaining series order
            const chunks = chunk(this.waypoints, 500); // Reduced chunk size for better performance
            
            // Use mapSeries to maintain sequential processing order
            const result = await mapSeries(chunks, async (waypoints) => {
                if (!waypoints?.length || waypoints.length < 2) {
                    return '';
                }
                
                try {
                    return await getCachedDirections(waypoints);
                } catch (error) {
                    console.error('Error getting directions for chunk:', error);
                    return ''; // Return empty string instead of throwing
                }
            });
            
            // if (!data?.directions?.length) {
            //     return '';
            // }
            
            // return data.directions.join(', ');
            // Filter out empty results and join
            const validDirections = result.filter(result => result.directions?.length);
            this.routeDetails = validDirections.map(result => result.directions.join(', ')).join(', ');
            const validWaypoints = result.filter(result => result.waypoints?.length);
            this.waypoints = validWaypoints.map(result => result.waypoints).flat().map(wp => new WayPoint({
                lon: wp.location[0],
                lat: wp.location[1],
            }));
            this.calculateDistances();
        } catch (error) {
            console.error('Could not build directions:', error);
            this.routeDetails = ''; // Return empty string on error
        }
    }
}

export class CharterRouteRun extends Deadrun {
    constructor(props) {
        super(props)
        this.charterId = ulid();
        this.type = 'charter#route'
        Object.assign(this, props);
        this.deadrun = true

        this.routeId = this.createId()
    }

    createId() {
        return `${this.startStopId}#${this.endStopId}#`;
        // return `${this.startStopId}#${this.endStopId}#${
        //     this.routeName?.length ? this.routeName : ""
        // }`;
    }
}